import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "diff-file-tree-items"
}
const _hoisted_2 = {
  key: 0,
  class: "tw-pt-1"
}

import DiffFileTreeItem from './DiffFileTreeItem.vue';
import {loadMoreFiles} from '../features/repo-diff.ts';
import {toggleElem} from '../utils/dom.ts';
import {diffTreeStore} from '../modules/stores.ts';
import {setFileFolding} from '../features/file-fold.ts';
import {computed, onMounted, onUnmounted} from 'vue';

const LOCAL_STORAGE_KEY = 'diff_file_tree_visible';


export default /*@__PURE__*/_defineComponent({
  __name: 'DiffFileTree',
  setup(__props) {

const store = diffTreeStore();

const fileTree = computed(() => {
  const result = [];
  for (const file of store.files) {
    // Split file into directories
    const splits = file.Name.split('/');
    let index = 0;
    let parent = null;
    let isFile = false;
    for (const split of splits) {
      index += 1;
      // reached the end
      if (index === splits.length) {
        isFile = true;
      }
      let newParent = {
        name: split,
        children: [],
        isFile,
      } as {
        name: string,
        children: any[],
        isFile: boolean,
        file?: any,
      };

      if (isFile === true) {
        newParent.file = file;
      }

      if (parent) {
        // check if the folder already exists
        const existingFolder = parent.children.find(
          (x) => x.name === split,
        );
        if (existingFolder) {
          newParent = existingFolder;
        } else {
          parent.children.push(newParent);
        }
      } else {
        const existingFolder = result.find((x) => x.name === split);
        if (existingFolder) {
          newParent = existingFolder;
        } else {
          result.push(newParent);
        }
      }
      parent = newParent;
    }
  }
  const mergeChildIfOnlyOneDir = (entries) => {
    for (const entry of entries) {
      if (entry.children) {
        mergeChildIfOnlyOneDir(entry.children);
      }
      if (entry.children.length === 1 && entry.children[0].isFile === false) {
        // Merge it to the parent
        entry.name = `${entry.name}/${entry.children[0].name}`;
        entry.children = entry.children[0].children;
      }
    }
  };
  // Merge folders with just a folder as children in order to
  // reduce the depth of our tree.
  mergeChildIfOnlyOneDir(result);
  return result;
});

onMounted(() => {
  // Default to true if unset
  store.fileTreeIsVisible = localStorage.getItem(LOCAL_STORAGE_KEY) !== 'false';
  document.querySelector('.diff-toggle-file-tree-button').addEventListener('click', toggleVisibility);

  hashChangeListener();
  window.addEventListener('hashchange', hashChangeListener);
});

onUnmounted(() => {
  document.querySelector('.diff-toggle-file-tree-button').removeEventListener('click', toggleVisibility);
  window.removeEventListener('hashchange', hashChangeListener);
});

function hashChangeListener() {
  store.selectedItem = window.location.hash;
  expandSelectedFile();
}

function expandSelectedFile() {
  // expand file if the selected file is folded
  if (store.selectedItem) {
    const box = document.querySelector(store.selectedItem);
    const folded = box?.getAttribute('data-folded') === 'true';
    if (folded) setFileFolding(box, box.querySelector('.fold-file'), false);
  }
}

function toggleVisibility() {
  updateVisibility(!store.fileTreeIsVisible);
}

function updateVisibility(visible) {
  store.fileTreeIsVisible = visible;
  localStorage.setItem(LOCAL_STORAGE_KEY, store.fileTreeIsVisible);
  updateState(store.fileTreeIsVisible);
}

function updateState(visible) {
  const btn = document.querySelector('.diff-toggle-file-tree-button');
  const [toShow, toHide] = btn.querySelectorAll('.icon');
  const tree = document.querySelector('#diff-file-tree');
  const newTooltip = btn.getAttribute(visible ? 'data-hide-text' : 'data-show-text');
  btn.setAttribute('data-tooltip-content', newTooltip);
  toggleElem(tree, visible);
  toggleElem(toShow, !visible);
  toggleElem(toHide, visible);
}

function loadMoreData() {
  loadMoreFiles(store.linkLoadMore);
}

return (_ctx: any,_cache: any) => {
  return (_unref(store).fileTreeIsVisible)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createCommentVNode(" only render the tree if we're visible. in many cases this is something that doesn't change very often "),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(fileTree.value, (item) => {
          return (_openBlock(), _createBlock(DiffFileTreeItem, {
            key: item.name,
            item: item
          }, null, 8 /* PROPS */, ["item"]))
        }), 128 /* KEYED_FRAGMENT */)),
        (_unref(store).isIncomplete)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("a", {
                class: _normalizeClass(['ui', 'basic', 'tiny', 'button', _unref(store).isLoadingNewData ? 'disabled' : '']),
                onClick: _withModifiers(loadMoreData, ["stop"])
              }, _toDisplayString(_unref(store).showMoreMessage), 3 /* TEXT, CLASS */)
            ]))
          : _createCommentVNode("v-if", true)
      ]))
    : _createCommentVNode("v-if", true)
}
}

})